if (!customElements.get('product-video')) {
  class ProductVideo extends HTMLElement {
    constructor() {
      super();
      this.videoButtons = document.querySelectorAll('.js-video-opener');
      this.videoTitle = this.querySelector('.pdp__video-title');
      this.paginationNumber = this.querySelector('.pdp__video-current');
      this.nextButton = this.querySelector('.pdp__video-navigation-button.next');
      this.prevButton = this.querySelector('.pdp__video-navigation-button.prev');
      this.closeButton = this.querySelector('.pdp__video-close');
      this.closeOverlay = this.querySelector('.pdp__video-close-overlay');
      this.volumeButton = this.querySelector('.video-volume-buttons');
      this.slides = this.querySelectorAll('.pdp__video-item');
      this.lastClickedId = null;
      this.activeIndex = 0;
      this.isMuted = false;
    }

    connectedCallback() {
      this.videoButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.slides.forEach((slide, index) => {
            if (slide.getAttribute('data-video-id') == button.getAttribute('data-video-id')) {
              slide.classList.add('active');
              this.videoTitle.textContent = slide.getAttribute('data-alt');
              this.paginationNumber.textContent = index + 1;
              this.activeIndex = index;
            } else {
              slide.classList.remove('active');
            }
          })
          this.classList.add('active');
        });
      });

      this.nextButton.addEventListener('click', () => {
        this.pauseActiveVideo();
        this.nextVideo();
      });

      this.prevButton.addEventListener('click', () => {
        this.pauseActiveVideo();
        this.prevVideo();
      });

      this.closeButton.addEventListener('click', (event) => {
        this.pauseActiveVideo();
        this.closeVideo(event);
      });

      this.closeOverlay.addEventListener('click', (event) => {
        this.pauseActiveVideo();
        this.closeVideo(event);
      });

      this.volumeButton.addEventListener('click', () => {
        this.toggleVolume();
      });

      document.addEventListener('keydown', (event) => {
        if (!this.classList.contains('active')) return;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
        }

        if (event.key === 'Escape') {
          this.pauseActiveVideo();
          this.closeVideo(event);
        }

        if (event.key === 'ArrowDown') {
          this.pauseActiveVideo();
          this.nextVideo();  
        }

        if (event.key === 'ArrowUp') {
          this.pauseActiveVideo();
          this.prevVideo();  
        }
      });
    }

    nextVideo() {
      const prevIndex = this.activeIndex;
      if (this.activeIndex < this.slides.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
      this.changeVideo(this.activeIndex, prevIndex);
    }

    prevVideo() {
      const prevIndex = this.activeIndex;
      if (this.activeIndex > 0) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.slides.length - 1;
      }
      this.changeVideo(this.activeIndex, prevIndex);
    }

    changeVideo(index, prevIndex) {
      this.slides[prevIndex]?.classList.remove('active');
      this.slides[index]?.classList.add('active');
      this.videoTitle.textContent = this.slides[index]?.getAttribute('data-alt');
      this.paginationNumber.textContent = index + 1;
    }

    pauseActiveVideo() {
      const activeSlide = this.slides[this.activeIndex];
      if (activeSlide) {
        if (activeSlide.classList.contains('pdp__video-item')) {
          const iframe = activeSlide.querySelector('iframe');
          const video = activeSlide.querySelector('video'); 
    
          if (iframe) {
            // YouTube
            if (iframe.src.includes('youtube.com')) {
              const currentSrc = iframe.src;
              iframe.src = currentSrc;  
            } 
            // Vimeo
            else if (iframe.src.includes('vimeo.com')) {
              iframe.contentWindow.postMessage('{"method":"pause"}', '*'); 
            }
          }
    
          if (video) {
            video.pause();  
          }
        }
      }
    }
    

    closeVideo(event) {
      event.preventDefault();
      this.classList.remove('active');
      this.slides.forEach(slide => {
        slide.classList.remove('active');
      });
      this.activeIndex = 0;
    }

    toggleVolume() {
      var tag = document.createElement('script');
      tag.src = "//www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

      const allIframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

      allIframes.forEach(iframe => {
        // YouTube
        if (iframe.src.includes('youtube.com')) {
          if (typeof YT !== 'undefined' && YT.Player) {
            const player = new YT.Player(iframe, {
              events: {
                onReady: (event) => {
                  if (this.isMuted) {
                    event.target.mute();
                  } else {
                    event.target.unMute();
                  }
                }
              }
            });
          } else {
            console.log('YT API not loaded yet.');
          }
        }

        // Vimeo
        else if (iframe.src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage(JSON.stringify({
            method: 'setVolume',
            value: this.isMuted ? 1 : 0
          }), '*');
        }
      });

      this.isMuted = !this.isMuted;

      if (this.volumeButton) {
        this.volumeButton.classList.toggle('muted', this.isMuted);
      }
      

    }
  }

  customElements.define('product-video', ProductVideo);
}
